import React from "react";

function gettable2(state){

    let curState;

    const criticalNDT = ["ndt8", "ndt10", "ndt11", "ndt12", "ndt13"];
    let flag = false;

    let result = [
        ["1", "ИТС 6-2015", "Обжиг портландцементного клинкера в одной вращающейся печи", "", 'Приказ Министерства природных ресурсов и экологии РФ от 2 апреля 2019 г. № 210 "Об утверждении нормативного документа в области охраны окружающей среды «Технологические показатели наилучших доступных технологий производства цемента»"', "", ""]
    ];

    for(let i = 0; i < criticalNDT.length; i++){
        for(let key in state.objects.ndt){
            if(state.objects.ndt[key].ndtres[criticalNDT[i]] !== "4"){
                curState = getNDTValueCode(state.objects, key, criticalNDT[i]);
                //console.log(curState);
                flag = true;
                break;
            }
        }
        if(flag){
            result.push(getpok(criticalNDT[i], curState));
        }
        flag = false;
    }

    return result;
}

function getpok(ndt, curState){
    //console.log(curState);
    //console.log(dictionary.ndt8.data);
    //console.log(dictionary.ndt8.data["1"]);
    switch (ndt) {
        case "ndt8":
            return ["", "", "НДТ 8 - Выбросы пыли из организованных источников", "", (dictionary.ndt8.data[curState].value + dictionary.ndt8.data[curState].unit), (dictionary.ndt8.data[curState].value + dictionary.ndt8.data[curState].unit), ""];
        case "ndt10":
            return ["", "", "НДТ 10 – Выбросы NOx в отходящих печных газах", "", (dictionary.ndt10.data[curState].value + dictionary.ndt10.data[curState].unit), (dictionary.ndt10.data[curState].value + dictionary.ndt10.data[curState].unit), ""];
        case "ndt11":
            return ["", "", "НДТ 11 – Выбросы NH3 в отходящих печных газах", "", (dictionary.ndt11.data[curState].value + dictionary.ndt11.data[curState].unit), (dictionary.ndt11.data[curState].value + dictionary.ndt11.data[curState].unit), ""];  
        case "ndt12":
            return ["", "", "НДТ 12 – Выбросы SO2  в отходящих печных газах", "", (dictionary.ndt12.data[curState].value + dictionary.ndt12.data[curState].unit), (dictionary.ndt12.data[curState].value + dictionary.ndt12.data[curState].unit), ""];  
        case "ndt13":
            return ["", "", "НДТ 13 - Выбросы СО в отходящих печных газах", "", (dictionary.ndt13.data[curState].value + dictionary.ndt13.data[curState].unit), (dictionary.ndt13.data[curState].value + dictionary.ndt13.data[curState].unit), ""]; 
    }
}

const dictionary = {
    ndt8: {
        name: 'Выбросы пыли из вращающейся печи (неорганическая пыль с содержанием SiO 2 до 20 %, код ЗВ 2909):',
        data: {
            "1":{
                name: 'Выбросы пыли из вращающейся печи (неорганическая пыль с содержанием SiO 2 до 20 %, код ЗВ 2909) для проектируемых технологических линий', 
                unit: 'мг/нм<sup>3</sup>',
                value: 'не более 25 '
            },
            "2": {
                name: 'Выбросы пыли из вращающейся печи (неорганическая пыль с содержанием SiO 2 до 20 %, код ЗВ 2909) для технологических линий, введённых в эксплуатацию после 2008 года', 
                unit: 'мг/нм<sup>3</sup>',
                value: 'не более 50 '
            },
            "3": {
                name: 'Выбросы пыли из вращающейся печи (неорганическая пыль с содержанием SiO 2 до 20 %, код ЗВ 2909) для технологических линий, введённых в эксплуатацию до 2008 года с модернизированными фильтрами', 
                unit: 'мг/нм<sup>3</sup>',
                value: 'не более 500 '
            },
            "4": {
                name: 'Выбросы пыли из вращающейся печи (неорганическая пыль с содержанием SiO 2 до 20 %, код ЗВ 2909) для технологических линий, введённых в эксплуатацию до 2008 года', 
                unit: 'мг/нм<sup>3</sup>',
                value: 'не более 1000 '
            },
        }
        
    },

    ndt10: {
        data: {
            "1": {
                name: 'Выбросы оксидов азота NOx из вращающейся печи для печей с циклонным теплообменником',
                unit: 'мг/нм<sup>3</sup>',
                value: 'не более 500 '
            },
            "2": {
                name: 'Выбросы оксидов азота NOx из вращающейся печи для длинных печей мокрого способа производства и печей Леполь',
                unit: 'мг/нм<sup>3</sup>',
                value: 'не более 800 '
            },
            "3": {
                name: 'Выбросы оксидов азота NOx из вращающейся печи для печей с циклонным теплообменником',
                unit: 'мг/нм<sup>3</sup>',
                value: 'не более 500 '
            }
        },
        comm: 'Среднее арифметическое за время проведения замеров'

    },

    ndt11: {
        data: {
            "1": {
                name: 'Проскок NH3',
                unit: 'мг/нм<sup>3</sup>',
                value: 'не более 30-50 '
            }
        },
    },
    ndt12: {
        data: {
            "1": {
                name: 'Выбросы диоксида серы SO2 из вращающейся печи (код ЗВ 0330)',
                unit: 'мг/нм<sup>3</sup>',
                value: 'не более 400 '
            }
        },
        comm: 'Среднее арифметическое за время проведения замеров'
    },
    ndt13: {
        data: {
            "1": {
                name: 'Выбросы оксида углерода CO из вращающейся печи (код ЗВ 0337',
                unit: 'мг/нм<sup>3</sup>',
                value: 'не более 600 '
            }
        },
        comm: '1) Среднее арифметическое за время проведения замеров'
    },
}

export default gettable2;
